// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3fYxN","errorLogs":"styles_errorLogs__1mi4u"};